import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';

import { AppMemoryService } from './../../core/app-memory.service';
import { AuthService } from './../../auth/auth.service';
import { GetService } from '../../core/get.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  host: {'class': 'header'}
})
export class HeaderComponent implements OnInit, OnDestroy {
  public close: boolean;

  constructor(
    public appMemory: AppMemoryService,
    public getService: GetService,
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute
  ) { }

  logout() {
    this.router.navigate(['login'], {});
    this.getService.logOut().then((res: any) => {
      console.log(res);
    }, (err: any) => {
      console.log(err);
    });

    this.authService.logout();
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }


  resetActivity(){
    if (this.close) {
      this.appMemory.resetPush();
    }
    this.close = !this.close;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/header/header.component.ts